import Vue from 'vue'
import VueTreeList from 'vue-tree-list'

Vue.use(VueTreeList)
